import { useTranslate } from '@tolgee/react'
import { useExceptionMessageHandler } from '@yard/utils/useExceptionMessageHandler'

export const usePierMessageHandler = () => {
  const { t } = useTranslate()
  const { getExceptionMessage } = useExceptionMessageHandler()

  const getSuccessMessage = (isEditing: boolean) => {
    return isEditing
      ? t('pierUpdatedSuccesfully', 'Pier updated successfully')
      : t('pierCreatedSuccesfully', 'Pier created successfully')
  }

  const getDeleteSuccessMessage = () => {
    return t('pierDeletedSuccesfully', 'Pier deleted successfully')
  }

  return {
    getExceptionMessage,
    getSuccessMessage,
    getDeleteSuccessMessage,
  }
}
